import React from 'react'

import './ToggleSwitch.scss'
import classNames from 'classnames'

const ToggleSwitch: React.FC<{
  onChange: () => void
  checked: boolean
  label?: string
}> = ({
  onChange, checked, label
}) => {
  return (
    <div className="ToggleContainer">
      {label}
      <label className={classNames('ToggleSwitch', { checked })}>

        <input type="checkbox" onChange={onChange} checked={checked} />
        <div className="ToggleSwitch-switch" />
      </label>
    </div>
  )
}

export default ToggleSwitch